<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменен филиал
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <before-after-log-item>
        <template v-slot:before>
          {{ getFilialName(item.oldFilial) }}
        </template>

        <template v-slot:after>
          {{ getFilialName(item.filial) }}
        </template>
      </before-after-log-item>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import { joinNotEmpty } from '@/util/string'

  export default {
    name: 'HistoryItemTypeFilial',
    components: { BeforeAfterLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      getFilialName (filial) {
        if (filial) {
          return joinNotEmpty([
            filial?.city,
            filial?.address,
          ]) || filial?.name
        } else {
          return 'неизвестный филиал...'
        }
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
